module.exports = "/images/logo-white.png?45687f22d1dd9296754a1549c91e38a3";